<template>
  <div class="box7">
    <div class="box6-top-box">
      <div class="blockone" ref="block"></div>
      <div class="pageTitle">
        <pageTitle
          title="学习路径一目了然&nbsp;&nbsp;做复合型测试人才"
          text="课程涵盖主流测试框架，覆盖多种测试方式。以项目驱动结合AI辅助，打造复合型测试人才"
          titleColor="#24375C"
          titColor="#86909C"
        />
      </div>
      <div class="info">4个月课程稳步提升，进阶测试人才</div>

      <div class="subject-content">
        <div class="arrow">
          <img
            src="../../../assets/coursePage/softwareTest/box7/arrow.png"
            alt
          />
        </div>
        <div class="demo-box">
          <div class="demo" v-for="(item, index) in list" :key="index">
            <div class="num">{{ item.num }}</div>
            <div class="title">{{ item.title }}</div>
            <div  class="text">{{ item.text }}</div>
            <div class="tips">{{ item.tip }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="box6-btm-box">
      <div class="courseContent"><b>课程内容</b><i></i></div>
      <div class="box6-btm">
        <div
          class="subject-box"
          v-for="(item, index) in subject"
          :key="index"
          ref="item"
          :style="{
            backgroundColor:
              cur == index && showAnswer ? '#fff' : 'transparent',
          }"
        >
          <div class="subject" @click="changeCur(index)">
            <div
              class="tag"
              :class="{ tag2: index > 7 }"
              :style="{ color: index > 7 ? '#23C3B6' : '#4080FF' }"
            >
              {{ item.tag }}
            </div>
            <div class="title">{{ item.title }}</div>
            <div
              class="icon"
              :class="{ 'img-rotate': cur == index && showAnswer }"
            >
              <img src="../../../assets/coursePage/ai/box6/icon-down.png" alt />
            </div>
          </div>

          <div
            class="course-content"
            :class="{ 'show-answer': cur == index && showAnswer }"
          >
            <div class="line"></div>

            <!-- <template v-if="item.light && item.light.length > 0">
              <div class="title-icon">
                <img
                  src="../../../assets/coursePage/softwareTest/box7/icon1.png"
                  alt
                />可解决的现实问题
              </div>
              <div class="main-text">
                <p v-for="j in item.light" :key="j">{{ j }}</p>
              </div>
            </template> -->

            <div class="title-icon special-title-icon">
              <img
                src="../../../assets/coursePage/softwareTest/box7/icon1.png"
                alt
              />主要内容
            </div>
            <!-- <div class="main-text ability" v-if="item.ability2">
              <p v-for="k in item.ability2" :key="k"><i></i>{{ k }}</p>
            </div> -->
            <div class="main-content">
              <!-- <h1 class="main-content-title">{{ i.title }}</h1> -->
              <div class="main-content-item" v-for="(i, index2) in item.content"
              :key="index2">
                <!-- <span v-for="(i2, index3) in i.arr" :key="index3">
                  {{ i2 }} <i v-if="index3 != i.arr.length - 1">、</i>
                </span> -->
                {{ i }}
              </div>
            </div>

            <div class="title-icon">
              <img
                src="../../../assets/coursePage/softwareTest/box7/icon2.png"
                alt
              />可掌握的核心能力
            </div>
            <div class="main-text ability">
              <p v-for="k in item.ability" :key="k"><i></i>{{ k }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
import scrollBox from "../common/scrollBox.vue";
import check from "../../../utils/check";
export default {
  components: {
    pageTitle,
    scrollBox,
  },
  mounted() {},
  data() {
    return {
      list: [
        {
          title:"鸿蒙分布式测试专训",
          text: "完成鸿蒙设备多端协同测试，发现2处跨设备兼容性问题",
          tip: "编写跨终端自动化脚本，通过华为认证核心考核",
          num: "L5",
        },
        {
          title: "五大场景性能压测实战",
          text: "模拟万人并发峰值场景，定位3处性能瓶颈(慢查询/内存泄漏)",
          tip: "输出调优报告，系统吞吐量提升 200%",
          num: "L4",
        },
        {
          title:"接口设计与自动化实战",
          text: "设计全链路测试方案，定位5类典型漏洞（参数校验/状态码异常等)",
          tip: "实现接口自动化，日均验证200+接口用例，缺陷发现效率提升60%",
          num: "L3",
        },
        {
          title: "Selenium/Appium自动化实战",
          text: "开发Web自动化脚本，执行效率提升80%",
          tip: "优化APP脚本兼容性，覆盖10+主流机型自动化测试",
          num: "L2",
        },
        {
          title: "Web/APP功能测试实战",
          text: "用Charles 抓包分析多端数据交互，精准定位3个功能逻辑漏洞",
          tip: "生成100+条规范测试用例，输出可落地缺陷报告",
          num: "L1",
        },
      ],
      subject: [
        {
          title: "AI测试基础",
          tag: "阶段一",
          content: [
            "· 软件测试基础理论",
            "· 测试用例设计方法",
            "· 软件的缺陷及管理",
            "· 项目实战"
          ],
          ability: [
            "能根据web和app项目功能需求，手工设计出验证软件质量的测试数据",
            "能将设计的测试数据精准取执行，手工验证发现软件问题",
            "能在管理工具中提交和关闭缺陷，手工对缺陷进行闭环管理"
          ],
        },
        {
          title: "AI功能测试",
          tag: "阶段二",
          content: [
            "· web手工测试",
            "· 数据库应用工具使用",
            "· 数据库应用SQL使用",
            "· 抓包应用"
          ],
          ability: [
            "能独立搭建WEB和APP测试环境，包括Linux服务器配置及Docker容器部署",
            "能手工设计并执行WEB和APP功能测试用例，精准发现功能缺陷",
            "能运用主流工具进行APP专项、性能及稳定性测试，定位并解决问题",
            "能使用Charles抓包定位问题，结合SQL完成数据构造、校验与清理",
            "能在缺陷管理工具中完成缺陷提交、跟踪与关闭，输出高质量测试报告",
            "能对大模型/智能体项目进行功能性、鲁棒性、伦理与合规性测试"
          ],
        },
        {
          title: "AI自动化测试",
          tag: "阶段三",
          content: [
            "· python基础",
            "· web自动化测试",
            "· web自动化框架Pytest",
            "· web自动化selenium库",
            "· APP自动化appium库"
          ],
          ability: [
            "能使用Python对WEB项目进行自动化测试，基于企业现有框架完成回归测试任务",
            "能使用Python对APP项目进行自动化测试，基于企业现有框架完成回归测试任务",
            "能独立设计并优化WEB和APP自动化测试框架，提升测试效率和代码可维护性",
            "能通过Jenkins实现自动化测试脚本的定时执行，融入企业CI/CD流程",
            "能结合AI技术提升自动化测试的智能水平，优化测试策略和执行效率"
          ],
        },
        {
          title: "AI接口测试",
          tag: "阶段四",
          content: [
            "· 接口及接口测试介绍",
            "· Postman实现接口测试",
            "· Jmeter实现接口测试",
            "· 代码实现接口测试",
            "· 接口测试扩展"
          ],
          ability: [
            "能使用Apifox进行接口测试，发送请求、关联参数、编写断言并生成测试报告",
            "能基于requests和pytest框架实现接口自动化测试，完成企业级接口测试任务",
            "能独立设计接口自动化测试框架，实现业务逻辑与测试代码的高效分离",
            "能使用Mock技术模拟接口响应，处理复杂接口依赖问题",
            "能结合AI技术优化接口测试流程，提升测试覆盖率和执行效率"
          ],
        },
        {
          title: "AI性能测试",
          tag: "阶段五",
          content: [
            "· 性能测试基础",
            "· Jmeter工具实施性能测试",
            "· 性能调优",
            "· 性能测试进阶"
          ],
          ability: [
            "能使用Jmeter进行性能测试，发送请求、构造数据、配置组件并生成性能测试报告",
            "能设计并执行单业务、混合业务、峰值、稳定性及异常场景的性能测试",
            "能通过JVM资源分析和数据库调优优化系统性能，解决性能瓶颈问题",
            "能使用Locust实现性能自动化测试，支持混合业务场景及分布式压测",
            "能结合AI技术优化性能测试流程，提升测试覆盖率和执行效率"
          ],
        },
        {
          title: "AI鸿蒙测试",
          tag: "阶段六",
          content: [
            "· 鸿蒙应用功能测试、专项测试",
            "· Hypium框架实现鸿蒙应用自动化测试"
          ],
          ability: [
            "能对鸿蒙应用进行功能测试，覆盖核心业务流程与模块",
            "能使用DevEco Testing实施专项测试，确保应用在多维度的质量",
            "能熟练运用鸿蒙命令行调试工具，进行性能分析与问题定位",
            "能基于Hypium框架设计并执行自动化测试，提升测试覆盖率与效率",
            "能结合AI技术优化测试流程，提升鸿蒙应用测试的智能化水平"
          ],
        },
      ],
      cur: 0,
      prevItemHeight: 0,
      showAnswer: true,
    };
  },
  methods: {
    openDetail() {
      if (localStorage.getItem(`detail-${check.getUrlParam("nid")}`)) {
        window.location.href = localStorage.getItem(
          `detail-${check.getUrlParam("nid")}`
        );
      } else {
        this.zixun("查看详细大纲");
      }
    },
    goTop(index) {
      window.scrollTo(
        0,
        this.$refs.item[index].offsetTop -
          this.$refs.block.offsetHeight -
          this.$refs.block.offsetHeight * 0.3 -
          this.prevItemHeight
      );
    },
    changeCur(index) {
      const a = document.querySelector(".show-answer");
      if (a != null && index > this.cur) {
        this.prevItemHeight = a.offsetHeight;
      }
      if (!this.showAnswer || index <= this.cur) {
        this.prevItemHeight = 0;
      }
      if (index == this.cur) {
        this.showAnswer = !this.showAnswer;
      } else {
        this.showAnswer = true;
        this.cur = index;
      }
      this.goTop(index);
    },
    toLink() {
      window.open("https://m.boxuegu.com/");
    },
    zixun(name) {
      zhuge.track("H5_软件测试专题页", {
        咨询按钮名称: name,
      });
      this.clickZiXun()
    },
  },
};
</script>

<style lang="less" scoped>
.pageTitle {
  padding: 0 36px;
}
.box6-top-box {
  width: 100%;
  background: url("../../../assets/coursePage/ai/box6/bg.png") no-repeat;
  background-size: cover;
}
.blockone {
  height: 80px;
}
.info {
  margin: 28px auto;
  padding: 0px 58px;
  padding-top: 48px;
  width: 726px;
  height: 144px;
  background: url("../../../assets/coursePage/softwareTest/box7/info.png")
    no-repeat;
  background-size: cover;
  box-sizing: border-box;
  text-align: center;
  font-size: 28px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #4e5969;
  line-height: 48px;
  .tit {
    margin-bottom: 4px;
    font-size: 28px;
    text-align: center;
    font-family: PingFangSC-Medium;
    font-weight: 500;
    color: #009ef8;
    line-height: 48px;
  }
}
.subject-content {
  position: relative;
  display: flex;
  justify-content: center;
  padding: 0px 32px 0 86px;
  box-sizing: border-box;

  .tag {
    position: absolute;
    top: -56px;
    left: 32px;
    font-size: 24px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #4b84fa;
    line-height: 44px;
  }
  .arrow {
    width: 18px;
    height: 1222px;
    img {
      width: 100%;
      height: 100%;
    }
  }

  .demo-box {
    margin-left: 26px;
    .demo {
      position: relative;
      margin-bottom: 32px;
      padding: 24px;
      padding-right: 24px;
      width: 572px;
      background: linear-gradient(
        90deg,
        rgba(255, 255, 255, 0.8) 0%,
        rgba(255, 255, 255, 0.2) 100%
      );
      border-radius: 16px;
      box-sizing: border-box;
      font-size: 24px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #86909c;
      line-height: 40px;

      &::after {
        position: absolute;
        top: 32px;
        left: -47px;
        content: "";
        min-width: 24px;
        max-width: 24px;
        height: 24px;
        background: rgb(241, 251, 253);
        border: 5px solid #4b84fa;
        border-radius: 50%;
        box-sizing: border-box;
      }
      .num {
        position: absolute;
        top: 24px;
        left: -98px;
        width: 34px;
        text-align: right;
        font-size: 28px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        color: #4b84fa;
        line-height: 40px;
      }
      .title {
        margin-bottom: 12px;
        font-size: 26px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #4b84fa;
        line-height: 40px;
      }
      .text {
        position: relative;
        padding-left: 20px;
        font-size: 24px;
        color: #4E5969;
        line-height: 36px;
        &::before {
          content: "";
          position: absolute;
          top: 18px;
          left: 0px;
          width: 4px;
          height: 4px;
          background: #4E5969;
          border-radius: 50%;
        }
      }
      .tips {
        position: relative;
        padding-left: 20px;
        font-size: 24px;
        color: #4E5969;
        line-height: 36px;
        &::before {
          content: "";
          position: absolute;
          top: 18px;
          left: 0px;
          width: 4px;
          height: 4px;
          background: #4E5969;
          border-radius: 50%;
        }
      }
    }
    .demo:last-child {
      margin-bottom: 8px;
    }
  }
}

.content-img {
  position: relative;
  .fixed {
    position: absolute;
    left: -8px;
    bottom: -19px;
    img {
      width: 148px;
    }
  }
}
.courseContent {
  position: relative;
  text-align: center;
  width: 288px;
  height: 244px;
  line-height: 244px;
  margin: -20px auto -50px;
  background: url("../../../assets/coursePage/softwareTest/box7/course-bg.png")
    no-repeat;
  background-size: 100% 100%;
  background-origin: center;
  b {
    text-align: center;
    font-size: 36px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #24375c;
    line-height: 50px;
    position: relative;
    z-index: 3;
  }
  i {
    width: 152px;
    height: 6px;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: 110px;
    background: #9cd4ff;
    border-radius: 2px;
    display: block;
  }
}
.tip {
  background: linear-gradient(
    270deg,
    rgba(255, 255, 255, 0) 0%,
    rgba(220, 243, 255, 0.31) 20%,
    rgba(218, 243, 255, 0.95) 49%,
    rgba(216, 242, 255, 0.31) 85%,
    rgba(255, 255, 255, 0) 100%
  );
  border-radius: 68px;

  font-size: 28px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #5381de;
  line-height: 76px;
  text-align: center;
  margin-top: 76px;
}
.box7 {
  padding: 0 0 0;
  box-sizing: border-box;
  width: 100%;
  font-family: PingFangSC, PingFang SC;
  // background: url("../../../assets/coursePage/softwareTest/box7/bg.png")
  //   no-repeat;
  // background-size: cover;
  // background-origin: center top;
  .topImg {
    height: 586px;
    object-fit: contain;
    margin: 78px 0 0px 150px;
  }
  /deep/ .scorll-box {
    margin-top: 30px;
    background: rgba(75, 132, 250, 0.16) !important;
  }
  /deep/ .container .scorll-box .scorll-block {
    background: #4b84fa !important;
  }
  .box6-btm-box {
    padding-bottom: 72px;
    width: 100%;
    background: linear-gradient(180deg, #f8fcff, #f8fcff 78%, #f8fcff);
    .box6-btm {
    }
  }

  .btn {
    margin: 0 auto;
    margin-top: 60px;
    width: 686px;
    height: 96px;
    background-image: linear-gradient(90deg, #3363fc 0%, #9b97ff 100%);
    box-shadow: 0px 0px 20px 0px #e6eef5;
    border-radius: 48px;
    text-align: center;
    font-family: PingFangSC-Semibold;
    font-size: 30px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 36px;
    letter-spacing: 2px;
    color: #ffffff;
    text-shadow: 0px 2px 6px #207dff;
    line-height: 96px;
  }

  .subject-box {
    margin: 0 auto;
    margin-bottom: 16px;
    width: 686px;
    // overflow: hidden;
    border-radius: 16px;
    box-shadow: 0px 12px 32px 0px rgba(94,123,218,0.08);
  }
  .subject {
    display: flex;
    align-items: center;
    position: relative;
    padding: 28px 32px;
    width: 100%;
    height: 96px;
    background: #FFFFFF;
    border-radius: 16px;
    box-sizing: border-box;
    z-index: 5;

    .tag {
      width: 96px;
      height: 40px;
      background: rgba(255,255,255,0.8);
      border-radius: 8px;
      border: 2px solid #E4F0FF;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 24px;
      color: #4080FF;
      line-height: 24px;
    }
    .tag2 {
      color: rgb(35, 195, 182);
    }
    .title {
      margin-left: 24px;
      margin-right: 20px;
      width: 472px;
      font-size: 28px;
      color: #4E5969;
    }

    .icon {
      width: 28px;
      height: 28px;
      transition: 0.5s ease all;
      img {
        width: 100%;
        height: 100%;
      }
    }

    .img-rotate {
      transition: 0.5s ease all;
      transform: rotate(180deg);
    }

    font-size: 28px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #4e5969;
  }

  .course-content {
    position: relative;
    width: 100%;
    box-sizing: border-box;
    background: #fff;
    max-height: 0;
    opacity: 0;
    transition: max-height 0.3s ease;
    overflow: hidden;
    z-index: 3;
    overflow-y: scroll;
    border-radius: 0 0 16px 16px;
    .line {
      margin-bottom: 32px;
      width: 606px;
      height: 1px;
      background: #f2f3f5;
    }
  }

  .show-answer {
    padding: 0px 32px 40px;
    // display: block;
    max-height: 3900px;
    opacity: 1;
    transition: max-height 0.4s ease;
  }

  .title-icon {
    display: flex;
    align-items: center;
    margin: 32px 0 16px;
    height: 44px;
    font-size: 24px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 600;
    color: #1d2129;
    line-height: 24px;

    img {
      margin-right: 12px;
      width: 24px;
      height: 24px;
      background-size: contain;
    }
  }
  .special-title-icon {
    margin-bottom: 24px;
  }
  .main-content {
    margin-left: 36px;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    .main-content-title {
      font-size: 26px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #1d2129;
      line-height: 44px;
      margin-bottom: 8px;
    }
    .main-content-item {
      margin: 0 24px 12px 0;
      font-size: 24px;
      color: #4E5969;
      line-height: 40px;
      text-align: left;
      span {
        display: inline-block;
        font-size: 24px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #4e5969;
        line-height: 40px;
      }
      i {
        margin-left: -4px;
      }
    }
    .block {
      margin-bottom: 16px;
      margin-right: 16px;
      padding: 8px 20px;

      border-radius: 8px;

      font-size: 24px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #4e5969;
      display: flex;
      align-items: center;

      background: rgba(106, 161, 255, 0.1);
      border-radius: 10px;
    }
  }

  .main-text {
    p {
      font-family: PingFang SC;
      font-size: 24px;
      color: #4E5969;
      line-height: 40px;
      margin-left: 35px;
      i {
        display: none;
        width: 4px;
        height: 4px;
        background: #87d4bd;
        border-radius: 2px;
        margin-right: 16px;
      }
    }
  }
  .ability {
    p {
      position: relative;
      &::before {
        content: "";
        display: block;
        width: 4px;
        height: 4px;
        background: #87D4BD;
        position: absolute;
        left: -22px;
        top: 18px;
        border-radius: 50%;
      }
    }
  }
}
</style>
